<script lang="ts">
    import type {ButtonStyle, ComponentSize} from 'shared/ui-widgets/types';
    import type {Placement} from '@floating-ui/core';
    import {Menu, MenuButton, MenuItems} from '@rgossiaux/svelte-headlessui';
    import {createFloatingActions} from 'svelte-floating-ui';
    import {offset} from 'svelte-floating-ui/dom';
    import {flip} from '@floating-ui/core';

    export let buttonStyle: ButtonStyle = 'default';
    export let buttonSize: ComponentSize = 'md';
    export let isDisabled = false;
    export let isBlock = false;
    export let additionalButtonClasses = '';
    export let additionalContainerClasses = '';
    export let additionalMenuClasses = '';
    export let id: string | null = null;
    export let dataQa: string | null = null;
    export let noWrap = false;
    export let useBootstrapStyles = true;
    export let defaultPlacement: Placement = 'bottom-end';

    const [floatingRef, floatingContent] = createFloatingActions({
        placement: defaultPlacement,
        strategy: 'fixed',
        middleware: [
            offset(2),
            flip()
        ]
    });

    const buttonClass = `btn btn-${buttonStyle} btn-${buttonSize} ${isBlock ? 'btn-block' : ''}`;
</script>

<Menu as="span" class="kp-dropdown-button btn-group {isBlock ? 'btn-block' : ''} {additionalContainerClasses}">
    <MenuButton id="{id}"
                use={[floatingRef]}
                disabled="{isDisabled}"
                data-qa="{dataQa}"
                class="{useBootstrapStyles ? buttonClass : ''} dropdown-toggle {additionalButtonClasses} {noWrap ? 'no-text-wrap' : ''}">

        <slot name="button"/>
    </MenuButton>

    <MenuItems as="ul"
               use={[floatingContent]}
               class="dropdown-menu dropdown-menu-shown {additionalMenuClasses}">

        <slot name="menu"/>
    </MenuItems>
</Menu>

<style lang="less">
    :global {
        .kp-dropdown-button {
            white-space: normal;

            .no-text-wrap {
                white-space: nowrap;
            }

            .dropdown-menu {
                max-height: 400px;
                overflow-y: auto;

                &.dropdown-menu-shown {
                    z-index: 1100;
                    display: block;
                }
            }
        }
    }
</style>